import React, { useRef, useState } from 'react';
import api from '../utils/api';
import { Button } from './ui/button';
import { Upload, X } from 'lucide-react';
import { toast } from 'sonner';

export const ImageUploader = ({ images, onChange }) => {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    
    setUploading(true);
    const newImages = images.slice();
    
    for (let i = 0; i < files.length; i++) {
      const fd = new FormData();
      fd.append('file', files[i]);
      try {
        const res = await api.post('/upload', fd, { 
          headers: { 'Content-Type': 'multipart/form-data' } 
        });
        // Store RELATIVE path (e.g. /api/uploads/xxx.jpg) so it works on
        // both preview and production via same-origin resolution.
        newImages.push(res.data.url);
      } catch (err) {
        toast.error('Upload failed');
      }
    }
    
    onChange(newImages);
    setUploading(false);
    if (fileRef.current) fileRef.current.value = '';
  };

  const removeImage = (idx) => {
    const newImages = images.filter((_, i) => i !== idx);
    onChange(newImages);
  };

  return (
    <div>
      <input 
        type="file" 
        ref={fileRef} 
        accept="image/*" 
        multiple 
        onChange={handleUpload} 
        className="hidden" 
      />
      <div className="flex flex-wrap gap-2 mb-2">
        {images.map((img, i) => (
          <div key={i} className="relative">
            <img src={img} className="w-16 h-16 object-cover rounded" alt="" />
            <button 
              type="button" 
              onClick={() => removeImage(i)} 
              className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full p-0.5"
            >
              <X size={12} />
            </button>
          </div>
        ))}
      </div>
      <Button 
        type="button" 
        variant="outline" 
        size="sm" 
        onClick={() => fileRef.current && fileRef.current.click()} 
        disabled={uploading}
      >
        <Upload size={16} className="mr-1" />
        {uploading ? 'Uploading...' : 'Upload Images'}
      </Button>
    </div>
  );
};
